import Dialog from 'epn-ui/umd/dist/components/Dialog';
import Button from 'epn-ui/umd/dist/components/Button';
import BaseEmpty from '@components/base/BaseEmpty';

// Helpers
import useI18n from '@i18n';
import { ISupportThemesAttributes } from '@api/types';

export interface IChooseThemeModalProps {
    isOpen: boolean;
    onClose: () => void;
    themes: ISupportThemesAttributes[];
    onSelect: (theme: ISupportThemesAttributes) => void;
    selectedTheme: ISupportThemesAttributes | null;
    afterClose: () => void;
}

const ChooseThemeModal: React.FC<IChooseThemeModalProps> = ({
    isOpen,
    onClose,
    themes,
    onSelect,
    selectedTheme,
    afterClose,
}) => {
    const { t } = useI18n('Support');

    return (
        <Dialog
            open={isOpen}
            onCancel={() => {
                onClose();
                afterClose();
            }}
            title={t('What happened?')}
            size="md"
        >
            <div id="support_choose_theme_modal">
                <div className="flex flex-wrap gap-4">
                    {Array.isArray(themes) &&
                        themes.length > 0 &&
                        themes.map(item => (
                            <Button
                                type={selectedTheme?.id === item.id ? 'primary' : 'default'}
                                onClick={() => onSelect(item)}
                                key={item.id}
                                className="w-full h-auto xs:w-auto min-h-[2.5rem]"
                            >
                                {t(item.name)}
                            </Button>
                        ))}
                </div>

                {Array.isArray(themes) && themes.length === 0 && <BaseEmpty />}
            </div>
        </Dialog>
    );
};

export default ChooseThemeModal;
